module.exports = __webpack_public_path__ + "img/湖南长远锂科股份有限公司.849a54bc.png";